import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import app from './modules/app'
import login from './modules/login'
import channelLogin from './modules/channel-login'
import share from './modules/share'

import getters from './getters'

Vue.use(Vuex)

// 监听每次调用mutations的时候,都会进入到这个方法,然后做一些处理,比如vuex中的状态信息持久化
const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data;
  },
};

const actions = {};

const store = new Vuex.Store({
  modules: {
    user,
    app,
    login,
    channelLogin,
    share
  },
  getters,
  mutations,
  actions
})

export default store
